(ns frontend.ui.component.lp-portal.report.module.tabular-card
  (:require
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.card.view :as card]
   [frontend.ui.component.table.view :as table-view]
   [frontend.ui.component.dynamic-table.view :as dynamic-table]
   [frontend.ui.component.lp-portal.text-content.view :as text-content]
   [frontend.ui.component.lp-portal.stacked-text-group.view :as stacked-text-group]
   [reagent.core :as r]
   [frontend.ui.style.theme.core :as theme]))

(defn raw-view
  [data props]
  [:div
   {:style {:display :flex
            :flex-direction :column
            :gap     "1rem"}}
   (apply (partial table-view/table-from-values (:footer-row? props)) (:figures data))
   (text-content/optional-footnote data props)])

(defn raw-stacked-table
  [data props]
  [:<>
   (into [:div]
         (concat (map #(apply stacked-text-group/stacked-text-group %)
                      (:figures data))))
   (text-content/optional-footnote data
                                   props)])

(defn dynamic-stacked-table
  [data props]
  [:<>
   (dynamic-table/dynamic-stack (:figures data))
   (text-content/optional-footnote data props)])

(defn view
  [title data props]
  [card/card
   {:title title}
   [raw-view data props]])

(defn dynamic-table
  [title data props]
  (let [removed-since-empty? (or (some->> data
                                          :figures
                                          :data
                                          (remove nil?)
                                          (empty?))
                                 (nil? (->> data
                                            :figures
                                            :data)))]
    (if (and (not (:edit-mode? props))
             removed-since-empty?)
      nil
      [card/expandable-card
       {:title title
        :removed-since-empty? removed-since-empty?}
       [:<>
        [dynamic-table/dynamic-table
         {:parsed-data (:figures data)
          :odd-row-background-color (if removed-since-empty?
                                      (theme/color [:palette :danger])
                                      (theme/color [:dynamic-table :odd-row :bg]))
          :even-row-background-color (theme/color [:dynamic-table :even-row :bg])
          :sub-heading-color (theme/color [:dynamic-table :heading-row :bg])}]
        (text-content/optional-footnote data props)]])))

(defn dynamic-table-no-heading
  [title data props]
  (let [removed-since-empty? (some->> data
                                      :figures
                                      :data
                                      (remove nil?)
                                      (empty?))]
    (if (and (not (:edit-mode? props))
             removed-since-empty?)
      nil
      [card/expandable-card
       {:title title
        :removed-since-empty? removed-since-empty?}
       [:<>
        [dynamic-table/dynamic-table-no-headings
         {:parsed-data (:figures data)
          :sub-heading-color (theme/color [:dynamic-table :heading-row :bg])
          :odd-row-background-color (theme/color [:dynamic-table :odd-row :bg])
          :even-row-background-color (theme/color [:dynamic-table :even-row :bg])}]
        (text-content/optional-footnote data props)]])))

(defn row-view
  [title data props]
  [:div
   {}
   (if (some-> data
               :figures
               :title)
     "wrong data format"
     [view title data props])])
